import { KeyboardArrowRight, Star, StarOutline, StarRate } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import AllMenuNavbr from "components/AllMenu/AllMenuNavbr";
import Footer from "components/Footer/Footer";
import React, { useState } from "react";
import Sliders from "@mui/material/Slider";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from "react-material-ui-carousel";
const resetbtn = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",

  width: "290px",
  height: "34px",
  background: "#FFFFFF",
  border: "1px solid #559A95",
  borderRadius: "6px",
  margin: " 0px auto",
};



function valuetext(value) {
  return ` $${value}`;
}
function SearchResult() {
  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const [PriceRange, setPriceRange] = useState([100, 400]);

  const handlerPriceRange = (event, newValue) => {
    setPriceRange(newValue);
  };
  const MobileResponsive = useMediaQuery('(max-width:800px)');
const data =  {
  Images: "/images/Russain75.svg",
  Images: "/images/Afganhis231.svg",
}


  return (
    <>
      <Box sx={{ width: "100%", height: "100vh" }}>
        <AllMenuNavbr />
        <Box>
          <Box
            sx={{
              pl: "5%",
              mb: 1,
            }}
          >
            <Typography variant="h4" fontWeight={"bold"}>
              “Arabian”
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "gray", textAlign: "center" }}
            >
              260+ Result for “arabian”
            </Typography>
          </Box>
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { lg: "row", sm: "row", md: "row", xs: "column" },
          }} >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: { lg: "320px", md: "320px", sm: "320px", xs: "410px" },
                flexDirection: "column",
                border: "1px solid #E1E1E6",
                height: { lg: 850, md: 850, xs: 850, sm: "auto" },
                textAlign: "left",
                // m:{lg: 2 , md: 0 ,xs: 0 ,sm: 5}
              }}
            >
              <Box>
                <Typography variant="h6" pl={3.8} pt={1.9}>
                  Sort By
                </Typography>
                <FormControl>
                  <RadioGroup
                    aria-label="options"
                    name="options"
                    value={selectedValue}
                    onChange={handleChange}
                  >
                    <Box
                      sx={{
                        width: {
                          lg: "324px",
                          md: "324px",
                          sm: "324px",
                          xs: "420px",
                        },
                      }}
                    >
                      <FormControlLabel
                        value="Best Match"
                        control={<Radio sx={{ marginLeft: "auto" }} />}
                        label="Best Match"
                        sx={{
                          display: "flex",
                          flexDirection: "row-reverse",
                          justifyContent: "flex-start",
                          pl: 4.4,
                        }}
                      />
                      <FormControlLabel
                        value="popular"
                        control={<Radio sx={{ marginLeft: "auto" }} />}
                        label="popular"
                        sx={{
                          display: "flex",
                          flexDirection: "row-reverse",
                          justifyContent: "flex-start",
                          pl: 4.4,
                        }}
                      />
                    </Box>
                  </RadioGroup>
                </FormControl>
              </Box>
              {/* Order Type is given */}
              <Box>
                <Typography variant="h6" pl={3.8}>
                  Order Type
                </Typography>

                <Box>
                  <FormControl>
                    <RadioGroup
                      aria-label="options"
                      name="options"
                      value={selectedValue}
                      onChange={handleChange}
                    >
                      <Box
                        sx={{
                          width: {
                            lg: "324px",
                            md: "324px",
                            sm: "324px",
                            xs: "420px",
                          },
                        }}
                      >
                        <FormControlLabel
                          value="Show only business subscription"
                          control={<Checkbox sx={{ marginLeft: "auto" }} />}
                          label="Show only business subscription"
                          sx={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            justifyContent: "flex-start",
                            pl: 4.4,
                          }}
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
              {/* Order Type is End */}
              <Box>
                <Typography variant="h6" pl={3.8} mb={1}>
                  Resto Settings
                </Typography>
                <Box
                  sx={{
                    width: {
                      lg: "250px",
                      md: "250px",
                      sm: "250px",
                      xs: "370px",
                    },
                    ml: { lg: 4, md: 4, sm: 4, xs: 3 },
                    textAlign: "center",
                    mb: { lg: 1, md: 1, sm: 1, xs: 0 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      pl: 3,
                      boxShadow: "1px  1px 4px #E1E1E6",
                    }}
                  >
                    <Typography color={" #545359"} sx={{ marginLeft: "-20px" }}>
                      <Star sx={{ color: "orange" }} /> Rated 4.0 +
                    </Typography>
                    <Box
                      sx={{
                        // sx={{
                        marginLeft: {
                          lg: "12px",
                          md: "12px",
                          sm: "12px",
                          xs: "62px",
                        },
                        borderRight: "1px solid #E1E1E6",
                      }}
                    ></Box>
                    <Typography
                      color={" #545359"}
                      sx={{
                        marginLeft: "10px",
                      }}
                      textAlign={"center"}
                    >
                      <Star sx={{ color: "orange" }} /> Rated 4.0 +
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* Price Range is given */}
              <Box>
                <Typography variant="h6" pl={3.8} mb={1}>
                  Price Range
                </Typography>

                <Box sx={{ pl: 3.4 }}>
                  <FormControl>
                    <RadioGroup
                      aria-label="Price Range"
                      name="Price Range"
                      value={selectedValue}
                      onChange={handleChange}
                    >
                      <Box>
                        <FormControlLabel
                          value="Monthly"
                          control={<Radio />}
                          label="Monthly"
                        />
                        <FormControlLabel
                          value="Weekly"
                          control={<Radio />}
                          label="Weekly"
                          sx={{ pl: 4.4 }}
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                  <Box sx={{ width: { lg: 280, md: 282, sm: 230, xs: 360 } }}>
                    <Sliders
                      getAriaLabel={() => "PriceRange"}
                      value={PriceRange}
                      onChange={handlerPriceRange}
                      valueLabelDisplay="on"
                      getAriaValueText={() => ` $ ${valuetext}`}
                      min={0}
                      max={1000}
                      step={1}
                    />
                  </Box>
                </Box>
                {/* Category  */}
                <Box>
                  <Typography variant="h6" pl={3.8} mb={1}>
                    Dietary
                  </Typography>
                  <Box>
                    <FormControl>
                      <RadioGroup
                        aria-label="Dietary"
                        name="Dietary"
                        value={selectedValue}
                        onChange={handleChange}
                      >
                        <Box
                          sx={{
                            width: {
                              lg: "324px",
                              md: "324px",
                              sm: "324px",
                              xs: "420px",
                            },
                          }}
                        >
                          <FormControlLabel
                            value="Vegetarian"
                            control={<Radio sx={{ marginLeft: "auto" }} />}
                            label="Vegetarian"
                            sx={{
                              display: "flex",
                              flexDirection: "row-reverse",
                              justifyContent: "flex-start",
                              pl: 4.4,
                            }}
                          />
                          <FormControlLabel
                            value="Vegan"
                            control={<Radio sx={{ marginLeft: "auto" }} />}
                            label="Vegan"
                            sx={{
                              display: "flex",
                              flexDirection: "row-reverse",
                              justifyContent: "flex-start",
                              pl: 4.4,
                            }}
                          />
                          <FormControlLabel
                            value="Halal"
                            control={<Radio sx={{ marginLeft: "auto" }} />}
                            label="Halal"
                            sx={{
                              display: "flex",
                              flexDirection: "row-reverse",
                              justifyContent: "flex-start",
                              pl: 4.4,
                            }}
                          />
                          <FormControlLabel
                            value="Low-crab"
                            control={<Radio sx={{ marginLeft: "auto" }} />}
                            label="Low-crab"
                            sx={{
                              display: "flex",
                              flexDirection: "row-reverse",
                              justifyContent: "flex-start",
                              pl: 4.4,
                            }}
                          />
                          <FormControlLabel
                            value="Gluten Friendly"
                            control={<Radio sx={{ marginLeft: "auto" }} />}
                            label="Gluten Friendly"
                            sx={{
                              display: "flex",
                              flexDirection: "row-reverse",
                              justifyContent: "flex-start",
                              pl: 4.4,
                            }}
                          />
                          <FormControlLabel
                            value="Lactose-Free"
                            control={<Radio sx={{ marginLeft: "auto" }} />}
                            label="Lactose-Free"
                            sx={{
                              display: "flex",
                              flexDirection: "row-reverse",
                              justifyContent: "flex-start",
                              pl: 4.4,
                            }}
                          />
                          <FormControlLabel
                            value="Dairy-Free"
                            control={<Radio sx={{ marginLeft: "auto" }} />}
                            label="Dairy-Free"
                            sx={{
                              display: "flex",
                              flexDirection: "row-reverse",
                              justifyContent: "flex-start",
                              pl: 4.4,
                            }}
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                    <Button
                      variant="outlined"
                      style={resetbtn}
                      sx={{
                        position: "relative", bottom: {
                          lg: 34,
                          md: 34,
                          sm: 18,
                          xs: -0.5
                        }
                      }}
                    >
                      Reset
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
            {/* AFter add slider */}
            <Box sx={{ margin: "20px" }}>
              <Typography
                variant="h6"
                fontSize={"600"}
                sx={{
                  fontSize: { lg: "24px", md: "24px", sm: "24px", xs: "16px" },
                }}
              >
                Cuisine
              </Typography>

              {
                MobileResponsive ? (
                  <>
                    <Carousel animation="fade"
                      sx={{
                        display: "flex",
                        flexDirection: {
                          lg: "row",
                          md: "row",
                          sm: "row",
                          xs: "row",
                        },

                      }}
                      indicators={false}

                    >
                      <Box sx={{ mb: { lg: 0, md: 0, sm: 0, xs: 2 }, width: "100%" }}>
                        <CardMedia
                          component={"img"}
                          src="/images/American81.svg"
                          sx={{ width: "100%" }}
                        ></CardMedia>
                      </Box>
                      <Box
                        sx={{
                          marginLeft: {
                            lg: "10px",
                            md: "10px",
                            sm: "10px",
                            xs: "0px",
                          },
                          mb: { lg: 0, md: 0, sm: 0, xs: 2 },
                          width: "100%",
                        }}
                      >
                        <CardMedia
                          component={"img"}
                          src="/images/Russain75.svg"
                          sx={{ width: "100%" }}
                        ></CardMedia>
                      </Box>
                      <Box
                        sx={{
                          marginLeft: {
                            lg: "10px",
                            md: "10px",
                            sm: "10px",
                            xs: "0px",
                          },
                          mb: { lg: 0, md: 1, sm: 0, xs: 1 },
                          width: "100%",
                        }}
                      >
                        <CardMedia
                          component={"img"}
                          src="/images/Afganhis231.svg"
                          sx={{ width: "100%" }}
                        ></CardMedia>
                      </Box>
                    </Carousel>

                  </>
                ) : (
                  <>
             
                    <Box sx={{
                      display: "flex",
                      flexDirection: {
                        lg: "row",
                        md: "row",
                        sm: "row",
                        xs: "row",
                      },

                    }}
                      indicators={false}

                    >
                      <Box sx={{ mb: { lg: 0, md: 0, sm: 0, xs: 2 }, }}>
                        <CardMedia
                          component={"img"}
                          src="/images/American81.svg"
                       
                        ></CardMedia>
                      </Box>
                      <Box
                        sx={{
                          marginLeft: {
                            lg: "10px",
                            md: "10px",
                            sm: "10px",
                            xs: "0px",
                          },
                          mb: { lg: 0, md: 0, sm: 0, xs: 2 },
                    
                        }}
                      >
                        <CardMedia
                          component={"img"}
                          src="/images/Russain75.svg"
                
                        ></CardMedia>
                      </Box>
                      <Box
                        sx={{
                          marginLeft: {
                            lg: "10px",
                            md: "10px",
                            sm: "10px",
                            xs: "0px",
                          },
                          mb: { lg: 0, md: 1, sm: 0, xs: 1 },
                      
                        }}
                      >
                        <CardMedia
                          component={"img"}
                          src="/images/Afganhis231.svg"
                        ></CardMedia>
                      </Box>
                      <Box
                        sx={{
                          marginLeft: {
                            lg: "10px",
                            md: "10px",
                            sm: "10px",
                            xs: "0px",
                          },
                          mb: { lg: 0, md: 1, sm: 0, xs: 1 },
                      
                        }}
                      >
                        <CardMedia
                          component={"img"}
                          src="/images/Right-arrow-icon87.svg"
                        ></CardMedia>
                      </Box>
                    </Box>
                  </>
                )
              }

              {/* Meal plan is given */}
              <Box
                sx={{
                  mt: "10px",
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight={"600"}
                  sx={{
                    fontSize: {
                      lg: "24px",
                      md: "24px",
                      sm: "24px",
                      xs: "16px",
                    },
                    mb: 1,
                  }}
                >
                  Meal Plan
                </Typography>
              </Box>
              {/* Meal plan card */}
              <Grid container columnSpacing={4}>
                {" "}
                {[1, 2, 3, 4].map((items) => {
                  return (
                    <>
                      <Grid item xs={12} md={12} key={items.index}>
                        <Card
                          sx={{
                            display: "flex",
                            flexDirection: {
                              lg: "row",
                              md: "row",
                              sm: "row",
                              xs: "column",
                            },
                            ml: { lg: "auto", sm: "auto", xs: "30px", md: "center" },
                            height: { lg: 158, md: 178, sm: "auto", xs: "auto" },
                            cursor: "pointer",
                            mb: { lg: 0.8, md: 3, xs: 3, sm: 2 },
                          }}
                        >
                          <CardMedia
                            component={"img"}
                            src="/images/Rectangle 8.png"
                            sx={{
                              width: { lg: 280, md: 280, sm: 180, xs: "auto" },
                              objectFit: "cover",
                              height: { lg: 158, md: 178, sm: "auto", xs: "auto" },
                            }}
                          />
                          <CardContent>
                            <Typography
                              variant="caption"
                              sx={{
                                fontSize: 14,
                                fontFamily: "Outfit",
                                color: "#559A95",
                                fontStyle: "normal",
                              }}
                              gutterBottom
                            >
                              Arabian Cusine
                            </Typography>
                            <Typography
                              gutterBottom
                              variant="body1"
                              component="div"
                              sx={{
                                fontSize: 20,
                                fontFamily: "Outfit",
                                color: "#1A1824",
                                fontStyle: "normal",
                              }}
                            >
                              Chicken and Broccoli Rice Casserole
                            </Typography>
                            <Box sx={{ display: "flex" }}>
                              <StarRate sx={{ color: "#FAA641" }} />
                              <Typography sx={{ color: "#FAA641" }}>
                                4.7
                              </Typography>
                              <img
                                src="/images/iMacMemoji.svg"
                                style={{
                                  width: 25,
                                  marginLeft: 6,
                                  borderRadius: 10,
                                  marginRight: 7,

                                  objectFit: "cover",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: 14,
                                  fontFamily: "Outfit",
                                  color: "#9EA3AE",
                                  fontStyle: "normal",
                                }}
                              >
                                Chef Juna Food
                              </span>
                            </Box>
                            <Typography
                              variant="body2"
                              style={{
                                fontSize: 14,
                                fontFamily: "Outfit",
                                color: "#9EA3AE",
                                fontWeight: 400,
                                fontStyle: "normal",
                                marginTop: 5,
                              }}
                            >
                              Lorem Ipsum is simply dummy text of the printing
                              and typesetting industry. Lorem Ipsum is simply
                              dummy text of the printing and typesetting
                              industry . . . .
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    </>
                  );
                })}
              </Grid>
            </Box>
          </Box>

        </Box>
        <Footer />
      </Box>
    </>
  );
}

export default SearchResult;
